import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import Overlay from '../../Miscelania/Overlay';
import { Tabs, Tab, Dropdown, MenuItem } from 'react-bootstrap';
import InputMask from 'react-input-mask';
import Select from 'react-select';

import { Modal } from 'react-bootstrap';
import TrainingsCertificationModalEditInstructorsTab from './TrainingsCertificationModalEditInstructorsTab';

class TrainingCertificationsModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      modal: false,
      staffs: [],
      instructors_data: [],
      loaded: 0,
      training_id: this.props.training_certification.training_id,
      date_start: this.props.training_certification.date_start,
      date_finish: this.props.training_certification.date_finish,
      c_hours: this.props.training_certification.c_hours,
      total_hours: this.props.training_certification.total_hours,
      presence_type: this.props.training_certification.presence_type,
      certification_id: this.props.training_certification.certification_id,
      certification_supplier_id: this.props.training_certification.certification_supplier_id,
      id: this.props.training_certification.id,
      certification_name: null,
      certifications: [],
      certification_suppliers: []
    };
    //handlers
    this.handleSelectChangeSupplier = this.handleSelectChangeSupplier.bind(this);

    this.edit = this.edit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  // Handlers
  handleNavTab(state, key) {
    var change = {};
    change[state] = key;
    this.setState(change);
    this.setState({overlay: {message: '', type: '', status: ''}});
  }
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }
  handleSelectChangeSupplier(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      if (event.value !== null) {
        this.props.handleAlert('', '', 'open');
        Promise.resolve(header).then(function(value) {
          fetch(config.get('api') + '/verificar/fornecedor/validade/' + event.value , { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
            if (responseJson.status === 'error') {
              self.props.handleAlert(responseJson.message, responseJson.status, 'open');
            } else {
              self.props.handleAlert('', '', 'closed');
            }
          });
        });
      }
    }
    this.setState(change);
  }

  //LM
  componentWillReceiveProps(newProps) {
    if (newProps.modal_props === true && typeof this.state.id === 'undefined' && newProps.certification_suppliers_modal !== []) {
      this.setState({
        modal: true,
        training_id: newProps.training_certification.training_id,
        date_start: newProps.training_certification.date_start_str,
        date_finish: newProps.training_certification.date_finish_str,
        c_hours: newProps.training_certification.c_hours,
        total_hours: newProps.training_certification.total_hours,
        presence_type: newProps.training_certification.presence_type,
        certification_id: newProps.training_certification.certification_id,
        certification_name: newProps.training_certification.certification.name,
        certification_supplier_id: newProps.training_certification.certification_supplier_id,
        id: newProps.training_certification.id,
        certifications: newProps.certifications,
        certification_suppliers: newProps.certification_suppliers_modal,
        staffs: newProps.staffs,
        instructors_data: newProps.instructors_data,
      });
    }
  }

  // Fetch salvando a edição
  edit (event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      training_id: this.state.training_id,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      c_hours: this.state.c_hours,
      total_hours: this.state.total_hours,
      presence_type: this.state.presence_type,
      certification_id: this.state.certification_id,
      certification_supplier_id: this.state.certification_supplier_id,
      id: this.state.id,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/treinamento/certificado', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.updateData(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  closeModal() {
    this.setState({
      modal: false,
      training_id: undefined,
      date_start: undefined,
      date_finish: undefined,
      c_hours: undefined,
      total_hours: undefined,
      certification_id: undefined,
      certification_supplier_id: undefined,
      id: undefined,
      certifications: undefined,
      certification_suppliers: undefined
    }, this.props.closeModalParent());
  }

  render() {
    var self = this;
    return (
      <div>
        <RequestApi ref={'request_api'} />
        <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
        <Modal show={this.state.modal} aria-labelledby="contained-modal-title-lg" bsSize={'large'}>
          <Modal.Header>
            <h4 className="pull-left">Editar aula/fornecedor</h4>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
            <div className="clearfix"></div>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={this.edit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Data de início:</label>
                    <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="Data de início" required />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Data de término:</label>
                    <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish " mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="Data de término" required />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Certificado:</label>
                    <input type="text" className="form-control" value={this.state.certification_name} disabled />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Fornecedor:</label>
                    <Select
                      className="form-field-name"
                      name="certification_supplier_id"
                      value={this.state.certification_supplier_id}
                      searchable={true}
                      placeholder={'Selecionar fornecedor'}
                      onChange={this.handleSelectChangeSupplier.bind(this, 'certification_supplier_id')}
                      options={this.state.certification_suppliers}
                      required
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Período:</label>
                    <input value={this.state.c_hours} name="c_hours" className="form-control" onChange={this.handleChange.bind(this, 'c_hours')} placeholder="Período da aula" />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>Total de horas:</label>
                    <input value={this.state.total_hours} name="date_start" className="form-control" onChange={this.handleChange.bind(this, 'total_hours')} placeholder="Total de horas da aula" />
                  </div>
                </div>
              </div>
              <div className="row">
                {self.props.status === 1 || self.props.status === 3 ? 
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>{"Tipo de modalidade"}:</label>
                      <Select
                        className="form-field-name"
                        name="presence_type"
                        value={this.state.presence_type}
                        searchable={true}
                        placeholder={"Selecionar tipo de modalidade"}
                        onChange={this.handleSelectChange.bind(this, 'presence_type')}
                        options={[
                        {value: "presencial", label: "Presencial"},
                        {value: "ead", label: "EAD"}
                        ]}
                        required
                      />
                    </div>
                  </div>
                  : ""
                }
              </div>
              <button type="submit" className="btn btn-primary btn-lg btn-block"><i className="fa fa-fw fa-save"></i> Salvar fornecedor</button>
            </form>
            <hr/>
            <TrainingsCertificationModalEditInstructorsTab status={self.props.status} total_hours={self.state.total_hours} date_start_str={self.props.date_start_str} date_finish_str={self.props.date_finish_str}  handleAlert={this.props.handleAlert} staffs={this.state.staffs} training_certification_id={this.props.training_certification_id} instructors_data={this.props.instructors_data} updateData={this.props.updateData} updateDataModal={this.props.updateDataModal} training_id={this.props.training_id}  />
          </Modal.Body>
          <Modal.Footer>
            <button className="btn btn-danger btn-sm pull-right" onClick={this.closeModal}>
            <i className="fa fa-fw fa-close"></i></button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default TrainingCertificationsModal;



// WEBPACK FOOTER //
// ./src/Components/Trainings/Elements/TrainingCertificationsModal.js